export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#49a4d5\"/><path d=\"M11 14c1-1.037 4-4 4-4l-4 4zm0 0l-2-2\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};